import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import * as moment from 'moment';

import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {OrderType} from 'src/app/models/OrderType';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {PreorderType} from 'src/app/models/PreorderType';
import {TerminalorderType} from 'src/app/models/TerminalorderType';
import {Venue} from 'src/app/models/Venue';
import {OrderService, numberToCurrency} from 'src/app/services/order.service';
import {checkIfOrder, checkIfOrderPool} from 'src/app/utils/utils';

@Component({
	selector: 'app-order-item-header-info',
	templateUrl: './order-item-header-info.component.html',
	styleUrls: ['./order-item-header-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderItemHeaderInfoComponent implements OnInit {
	public order: Order;
	public orderPool: OrderPool;
	numberToCurrency = numberToCurrency;
	public type: PreorderType | TerminalorderType | null;
	public paymentMethod: PaymentMethod | null;
	public paymentMethodEnum = PaymentMethod;
	public orderType = OrderType;
	checkIfOrder = checkIfOrder;
	checkIfOrderPool = checkIfOrderPool;
	@Input() set orderValue(value: Order | OrderPool) {
		if (value) {
			if (checkIfOrder(value)) {
				this.order = value;
				this.type = this.orderService.getOrderPreorderOrTerminalType(value);
				this.paymentMethod = this.orderService.getPaymentMethod(value);
			}
			if (checkIfOrderPool(value)) {
				this.orderPool = value;
				this.type = null;
				this.paymentMethod = null;
			}
		}
	}
	@Input() venue: Venue | null;

	constructor(private orderService: OrderService) {}

	ngOnInit() {}

	getColorByMethod(method: PaymentMethod | null) {
		switch (method) {
			case PaymentMethod.CASH:
				return '#1F3A7F';

			case PaymentMethod.CREDIT_CARD:
				return '#8480BB';

			default:
				return '#1F3A7F';
		}
	}

	showCountdown() {
		if (this.order && this.order.status === OrderStatus.IN_PREPARATION) {
			if (
				this.order.type === OrderType.PREORDER ||
				this.order.type === OrderType.UBER ||
				this.order.type === OrderType.WOLT ||
				this.order.type === OrderType.LIEFERANDO
			)
				return true;
		}
		return false;
	}

	showOldVersionFlag() {
		return (
			!this.order?.clientMeta &&
			this.order.type === this.orderType.PREORDER &&
			this.order.method !== PaymentMethod.JET &&
			this.order.method !== PaymentMethod.WOLT &&
			this.order.method !== PaymentMethod.UBER_EATS
		);
	}

	orderedAtForAsap(order: Order) {
		if (this.venue?.slot?.active && this.venue?.slot?.readyOffset) {
			return moment(order.createdAt)
				.add(this.venue?.slot?.readyOffset, 'm')
				.toISOString();
		} else {
			return moment(order.createdAt).add(10, 'm').toISOString();
		}
	}
}
